import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	CourseSearchState,
	_STATE_COURSE_SEARCH_FEATURE_KEY,
} from './course-search.reducer';

export const getStateCoursesSearchState = createFeatureSelector<CourseSearchState>(
	_STATE_COURSE_SEARCH_FEATURE_KEY,
);

export const getStateCourses = createSelector(
	getStateCoursesSearchState,
	(state: CourseSearchState) => state.courses,
);

export const getStateUniversityCourses = createSelector(
	getStateCoursesSearchState,
	(state: CourseSearchState) => state.uni,
);

export const getStateCourseSearchPayload = createSelector(
	getStateCoursesSearchState,
	(state: CourseSearchState) => state.courseSearchPayload,
);

export const getStateUniCourseSearchPayload = createSelector(
	getStateCoursesSearchState,
	(state: CourseSearchState) => state.uniCourseSearchPayload,
);

export const getStateClearingCourses = createSelector(
	getStateCoursesSearchState,
	(state: CourseSearchState) => state.clearingCourses,
);

export const getStateClearingCourseSearchPayload = createSelector(
	getStateCoursesSearchState,
	(state: CourseSearchState) => state.clearingCourseSearchPayload,
);

export const getStateClearingUniCourseSearchPayload = createSelector(
	getStateCoursesSearchState,
	(state: CourseSearchState) => state.clearingUniCourseSearchPayload,
);

export const getStateCourseSearchIsLoading = createSelector(
	getStateCoursesSearchState,
	(state: CourseSearchState) => state.isLoading,
);

export const getStateCourseSearchIsPaginationLoading = createSelector(
	getStateCoursesSearchState,
	(state: CourseSearchState) => state.isLoadingPagination,
);

export const getStateCourseSearchClearingUni = createSelector(
	getStateCoursesSearchState,
	(state: CourseSearchState) => state.clearingUni,
);

export const getStateCourseSearchFilterPills = createSelector(
	getStateCoursesSearchState,
	(state: CourseSearchState) => state.filterPills,
);

export const getStateCourseSearchFilterToBeRemoved = createSelector(
	getStateCoursesSearchState,
	(state: CourseSearchState) => state.filterToBeRemoved,
);

export const getStateCourseSearchError = createSelector(
	getStateCoursesSearchState,
	(state: CourseSearchState) => state.error,
);
